(function () {
    'use strict';

    angular
		.module('skillsApp')
		.controller('AdminDepartmentsController', AdminDepartmentsController);

    function AdminDepartmentsController($scope, $state, $stateParams, $translate, logger, departments, groupsAndFunctions, dataService, notifyingService, jsReportService) {
        var vm = this;
        var _lazyLoadQualities = _.debounce(loadQualities, 300);
        
        vm.departments = departments;
        vm.roles = [];
        
        vm.gridOptions = {
            enableFiltering: true,
            appScopeProvider: vm,
            onRegisterApi: function (gridApi) {
                vm.gridOptions.gridApi = gridApi;
            },
            columnDefs: [
                {
                    displayName: $translate.instant('skill'),
                    name: 'actionName',
                    enableColumnMenu: false
                },
                {
                    displayName: $translate.instant('employee'),
                    name: 'employeeName',
                    enableColumnMenu: false
                },
                {
                    displayName: $translate.instant('function'),
                    name: 'functionName',
                    enableColumnMenu: false,
                    enableFiltering: false
                },
                {
                    displayName: $translate.instant('progress'),
                    name: 'progress',
                    cellTemplate: '/app/templates/common/userquality-progress-cell.tpl.html',
                    enableColumnMenu: false,
                    width: 150,
                    enableFiltering: false
                },
                {
                    displayName: $translate.instant('expiry_date'),
                    name: 'dateOfExpiry',
                    cellTemplate: '/app/templates/common/date-of-expiry-cell.tpl.html',
                    width: 150,
                    enableColumnMenu: false,
                    enableFiltering: false
                },
                {
                    displayName: '',
                    name: 'buttons',
                    cellTemplate: '/app/templates/admin-departments/quality-grid-buttons.tpl.html',
                    width: 100,
                    minWidth: 100,
                    enableColumnMenu: false,
                    enableFiltering: false
                }
            ]
        };

        vm.downloadExcel = downloadExcel;
        vm.downloadPdf = downloadPdf;
        vm.editEntity = editEntity;
        vm.isCurrentState = isCurrentState;
        vm.loadQualities = loadQualities;
        vm.selectedDepartmentChanged = selectedDepartmentChanged;

        notifyingService.subscribe($scope, 'userquality-updated', function (event, args) {
            if (!vm.selectedUserQuality) return;
            if (args.id !== vm.selectedUserQuality.id) return;
            loadQualities();
        });

        $scope.$watch('vm.filterValues', function (o, n) {
            if (o === n) return;
            loadQualities();
        }, true);

        $scope.$watch('vm.selectedRole', function (o, n) {
            if (o === n) return;
            loadQualities();
        });

        _initialize();

        function _downloadReport(type) {
            var reportInfo = {
                departmentName: vm.selectedDepartment.name,
                roleName: vm.selectedRole.roleName,
                filterValues: vm.filterValues
            };
            var items = vm.gridOptions.data;

            return jsReportService.getDepartmentsUserQualitiesReport(type, reportInfo, items);
        }

        function _initialize() {
            vm.selectedDepartment = departments[0];
            _getRolesForDepartment();
        }
        
        function _getRolesForDepartment() {
            var group = _.find(groupsAndFunctions, function (o) { return o.id === vm.selectedDepartment.id; });
            var roles = [];

            angular.copy(group.roles, roles);
            roles = _.sortBy(roles, function (o) { return o.roleName.toLowerCase(); });
            roles = _.uniq(roles, _.iteratee('roleId'));
            
            roles.unshift({ roleId: null, roleName: $translate.instant('all') });
            
            vm.roles = roles;

            var selectedRole = _.find(roles, function (o) { return vm.selectedRole ? o.roleId === vm.selectedRole.roleId : false; });
            
            vm.selectedRole = selectedRole || vm.roles[0];
        }

        function downloadExcel() {
            return _downloadReport('xlsx');
        }

        function downloadPdf() {
            return _downloadReport('pdf');
        }

        function editEntity(entity) {
            vm.selectedUserQuality = entity;
            $state.go($state.current.name + '.userquality', { id: entity.id });
        }

        function isCurrentState() {
            return $state.is('app-main.admin-departments');
        }

        function loadQualities() {
            vm.gridOptions.data = [];

            var params = {
                departmentId: vm.selectedDepartment.id,
                roleId: vm.selectedRole.roleId,
                assignedTo: vm.filterValues.assignedTo,
                status: vm.filterValues.status,
                connected: vm.filterValues.connected,
                doesNotApply: vm.filterValues.doesNotApply
            };

            return dataService.getUserQualities(params).then(userQualities => {
                // todo: sort by actionname, employeename, functionrolename
                vm.gridOptions.data = userQualities;
                vm.gridOptions.gridApi.core.handleWindowResize();
            });
        }
        
        function selectedDepartmentChanged() {
            _getRolesForDepartment();
        }
    }
})();